import React, { useEffect, useState } from 'react';
import './styles.scss';

const send = (payload: Record<string, unknown>): void => {
  try {
    (window as any).skyrimPlatform.sendMessage(JSON.stringify(payload));
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('captureConsent sendMessage', payload);
  }
};

// Auto-refuse if the requester never answers - matches the mockup's
// countdown idea, but purely client-side (no new server field): the
// existing `answer(false)` call is just invoked on a timer instead of a
// click. Reset per-request via the effect's dependency on `text`.
const AUTO_ANSWER_MS = 30000;

const CaptureConsent = () => {
  const [text, setText] = useState<string | null>(null);
  const [remainingMs, setRemainingMs] = useState(AUTO_ANSWER_MS);

  useEffect(() => {
    const showHandler = (e: Event) => {
      const detail = (e as CustomEvent).detail as { text: string };
      setText(detail.text);
    };
    const hideHandler = () => setText(null);

    window.addEventListener('skymp5-client:showCaptureConsent', showHandler);
    window.addEventListener('skymp5-client:hideCaptureConsent', hideHandler);
    return () => {
      window.removeEventListener('skymp5-client:showCaptureConsent', showHandler);
      window.removeEventListener('skymp5-client:hideCaptureConsent', hideHandler);
    };
  }, []);

  const answer = (accepted: boolean): void => {
    send({ action: 'captureConsent', accepted });
  };

  useEffect(() => {
    if (text === null) return;
    setRemainingMs(AUTO_ANSWER_MS);
    const start = Date.now();
    const interval = setInterval(() => {
      const left = AUTO_ANSWER_MS - (Date.now() - start);
      if (left <= 0) {
        clearInterval(interval);
        answer(false);
        return;
      }
      setRemainingMs(left);
    }, 250);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [text]);

  if (text === null) return null;

  return (
    <div className="capture-consent-overlay">
      <div className="capture-consent">
        <div className="capture-consent__title">Demande</div>
        <div className="capture-consent__text">{text}</div>
        <div className="capture-consent__countdown">{Math.ceil(remainingMs / 1000)}s</div>
        <div className="capture-consent__actions">
          <button className="capture-consent-btn" onClick={() => answer(true)}>Autoriser</button>
          <button className="capture-consent-btn capture-consent-btn--ghost" onClick={() => answer(false)}>Refuser</button>
        </div>
      </div>
    </div>
  );
};

export default CaptureConsent;
